import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export async function enableEventPublicLink(eventId: string): Promise<{ token: string; url: string }> {
  const fn = httpsCallable<{ eventId: string }, { token: string; url: string }>(
    functions,
    'enableEventPublicLink',
  );
  const result = await fn({ eventId });
  return result.data;
}

export async function disableEventPublicLink(eventId: string): Promise<void> {
  const fn = httpsCallable<{ eventId: string }, { ok: boolean }>(
    functions,
    'disableEventPublicLink',
  );
  await fn({ eventId });
}

export interface RegistrationLandingData {
  eventId: string;
  title: string;
  description: string;
  location: string;
  startDate: string | null;
  endDate: string | null;
  registrationDeadline: string | null;
  maxParticipants: number | null;
  registrationCount: number;
}

export async function getRegistrationLanding(eventId: string): Promise<RegistrationLandingData> {
  const fn = httpsCallable<{ eventId: string }, RegistrationLandingData>(
    functions,
    'getRegistrationLanding',
  );
  const result = await fn({ eventId });
  return result.data;
}

export async function submitRegistration(
  eventId: string,
  payload: Record<string, string>,
): Promise<{ participantId: string }> {
  const fn = httpsCallable<
    { eventId: string; payload: Record<string, string> },
    { participantId: string }
  >(functions, 'submitRegistration');
  const result = await fn({ eventId, payload });
  return result.data;
}

export async function sendInviteEmails(eventId: string, participantIds: string[]): Promise<void> {
  const fn = httpsCallable<{ eventId: string; participantIds: string[] }, { ok: boolean }>(
    functions,
    'sendInviteEmails',
  );
  await fn({ eventId, participantIds });
}

export async function applyChecklistTemplate(
  eventId: string,
  templateId: string,
): Promise<{ count: number }> {
  const fn = httpsCallable<{ eventId: string; templateId: string }, { count: number }>(
    functions,
    'applyChecklistTemplate',
  );
  const result = await fn({ eventId, templateId });
  return result.data;
}
